import styled from '@emotion/styled';
import { useSignPageControl } from '../../use-sign-page-control';
import Button from '@/components/comm/Button';
import { breakpointSmall } from '@/constants/breakpoints';
import { colors } from '@/constants/colors';

const NotUserDiv = styled.div`
padding: 40px 32px;
text-align: center;

@media (max-width: ${breakpointSmall}) {
  padding: 40px 20px;
}
`;

const ContentFirstDiv = styled.div`
color: ${colors.black};
font-size: 18px;
font-weight: 700;
line-height: 26px;
word-break: keep-all;

@media (max-width: ${breakpointSmall}) {
  font-size: 15px;
}
`;

const ContentSecondDiv = styled.div`
margin-top: 17px;
color: ${colors.indigo};
font-size: 14px;
font-weight: 400;
line-height: 24px;
word-break: keep-all;
`;

const BottomBtn = styled(Button)`
width: 100%;
height: 54px;
margin-top: 340px;
  
@media (max-width: ${breakpointSmall}) {
  margin-top: 200px;
}
`;

const NotUser = () => {
  const { push } = useSignPageControl();

  return (
    <NotUserDiv>
      <ContentFirstDiv>일치하는 계정 정보가 없어요<br />회원가입 후 다양한 서비스를 이용해보세요</ContentFirstDiv>
      <ContentSecondDiv>프로그래머스 인증시험 계정 하나로<br />프로그래머스 서비스도 편리하게 이용할 수 있어요!</ContentSecondDiv>
      <BottomBtn onClick={() => push('up')}>회원가입하기</BottomBtn>
    </NotUserDiv>
  );
};

export default NotUser;
